import React from 'react'
import { USER } from 'helpers/constants'
import ImageWithDefault from './ImageWithDefault'

const ProfileImage = ({ defaultSrc, ...rest }) => (
  <ImageWithDefault {...rest} defaultSrc={defaultSrc} />
)

ProfileImage.defaultProps = {
  defaultSrc: USER.PROFILE_IMG.DEFAULT,
}

export default ProfileImage
